export default "__VITE_ASSET__DfDrB3lY__"